import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import GetIcon from "Utils/Helpers/GetIcon";
import { decodeText } from "Utils/Helpers/TextDecoder";

export default function MainPara({
  title,
  text,
  social,
  CharCode,
  charType,
  align,
}) {
  const { t } = useTranslation();
  return (
    <div
      className={`para-main ${charType ? "char-type" : ""} ${
        align ? align : "text-center"
      }`}
    >
      <h2
        className="title"
        dangerouslySetInnerHTML={{ __html: decodeText(t(title)) }}
      />
      <p dangerouslySetInnerHTML={{ __html: decodeText(t(text)) }} />
      {social && (
        <div className="social">
          {social.map((i, index) => {
            return (
              <Tooltip title={i.name} key={"home-social" + index}>
                <Link to={i.link} target="_blank">
                  <GetIcon iconKey={i.icon} />
                </Link>
              </Tooltip>
            );
          })}
        </div>
      )}
    </div>
  );
}
